import { connect } from "react-redux";

import { setDailyTimespanAction, chartsSetDataSourceAction } from "../model/Diagramme";

import DailyValuesInfoPanel from "./DailyValuesInfoPanel";
import { requestDailyStatistics } from "../model/util/DailyValues";
import { requestDailyStatisticsOfHeDataLogFiles } from "../model/util/HeDataLogFiles";

const location2type = {
	"load_non-load_ratio": "last_leerlauf",
	"motor_starts" : "motorstarts",
	"specific_power" : "spezifische_leistungsaufnahme",
	"energy_consumption": "energieverbrauch"
};

export default connect(state => ({
	timespan: state.charts.daily_values.timespan,
	today: new Date(state.rtc),
	dataSourceOfCharts: state.charts.data_source_index,
	sortedListOfHeDataLogFiles: state.he_data_log_files.sortedListOfAvailableDays
}), (dispatch, own_props) => ({
	setTimespan: timespan => {
		let parts = own_props.location.pathname.split("/");
		let type = location2type[parts[parts.length - 1]];
		requestDailyStatistics(type, timespan.from_ms, timespan.until_ms, dispatch);
		dispatch(setDailyTimespanAction(timespan.from_ms, timespan.until_ms));
	},
	setTimespanHeDataLogFiles: (timespan, sortedListOfHeDataLogFiles) => {
		let parts = own_props.location.pathname.split("/");
		let type = location2type[parts[parts.length - 1]];
		dispatch(setDailyTimespanAction(timespan.from_ms, timespan.until_ms));
		requestDailyStatisticsOfHeDataLogFiles(type, timespan, sortedListOfHeDataLogFiles, dispatch);
	},
	setDataSourceOfCharts: (dataSourceIndex) => {
		dispatch(chartsSetDataSourceAction(dataSourceIndex))
	}
}))(DailyValuesInfoPanel);
